// extracted by mini-css-extract-plugin
export default {"Badge":"RptTransactionsCell_Badge__I32vm","Icon":"RptTransactionsCell_Icon__p-8MF","Label":"RptTransactionsCell_Label__xNiv5"};